export interface FormData {
  firstName: string;
  middleName: string;
  lastName: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  postalCode: string;
  ssn: string;
  acceptedTerms: boolean;
  attested: boolean;
}

export const defaultValues: FormData = {
  firstName: "",
  middleName: "",
  lastName: "",
  address: "",
  address2: "",
  city: "",
  state: "",
  postalCode: "",
  ssn: "",
  acceptedTerms: false,
  attested: false,
};
